export default "__VITE_ASSET__DmPEpx_r__"